import { MIME_TYPE_LOOKUPS } from './mime-types';

export function lookupMimeTypeFromString(mime: string) {
  return MIME_TYPE_LOOKUPS.get(mime);
}
